<template>
  <div class="container">
    <div class="wenjuan" v-if="!isTipShow">
      <div class="prev" @click="pace--" v-if="pace > 0">
        <img src="../../assets/prev.png" alt="" />
        <!-- {{ pace }}-{{ foundation.length }} -->
      </div>
      <div class="main padding_lr">
        <div class="center" v-if="pace == 0">
          <!-- 年龄 -->
          <div class="flex ages box">
            <div class="tite">
              <span style="font-size: 4vw; font-weight: 600">年龄</span
              ><span style="font-size: 3vw">（岁）</span>
            </div>
            <div class="ages_nr flex">
              <div class="age_num">{{ age }}</div>
              <div class="select_date" @click="show = true">
                <span>{{ currentDate | currentDateF }}</span>
                <van-icon name="arrow-down" />
              </div>
            </div>
          </div>
          <div class="btnFooter" @click="next">下一步</div>
        </div>
        <div class="center" v-else-if="pace == 1">
          <!-- 视力 -->
          <!--  <input type="text" /> -->
          <!-- <div @click="openVision">
              <span>左眼视力：</span>
              <div class="input"></div>
            </div>
            <div @click="openVision">
              <span>右眼视力：</span>
              <div class="input"></div>
            </div> -->
          <div class="box padding-lr">
            <vision @change="visionChang"> </vision>
          </div>
        </div>
        <!-- 问题 -->
        <div class="center" v-else-if="pace == 2">
          <div class="flex question box">
            <div class="items">
              <div
                :class="['item', questionIndex == index ? 'item_a' : '']"
                v-for="(item, index) in questionList"
                :key="index"
                @click="onSelect(index)"
              >
                <div class="item_nr">
                  <!-- <span class="icon">xxx</span> -->
                  <div class="icon">
                    <img
                      :src="questionIndex == index ? item.iocn_a : item.iocn"
                      alt=""
                    />
                  </div>

                  <span class="name">
                    {{ item.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="btnFooter" @click="next">下一步</div>
        </div>
        <!-- 分类问题 -->
        <div class="center" v-else>
          <template v-if="foundation[pace].type == 2">
            <vision @change="visionChang"> </vision>
          </template>
          <template v-else>
            <div
              v-for="(item, index) in foundation[pace].option"
              :key="index"
              class="option-item"
              @click="option(index)"
            >
              {{ item }}
            </div>
          </template>

          <!-- <div class="question">{{ list[0].tit }}</div> -->
        </div>
      </div>
      <div class="problem_box">
        <img src="../../assets/maotouy.png" alt="" class="maotouy" />
        <div class="union">
          {{ questionnaire }}
        </div>

        <!-- <van-icon name="arrow-left" @click="pace--" /> -->
      </div>
    </div>
    <div id="imgContainer" v-else>
      <img id="showImg" src="../../assets/common/tip.png" alt="" />
      <p>您准备好了吗，让我们开始吧！</p>
      <div class="btnNext" @click="onNext">下一步</div>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :max-date="maxDate"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="show = false"
      />
    </van-popup>
    <!-- 视力选择 -->
    <!-- <van-field
      readonly
      clickable
      label="城市"
      :value="value"
      placeholder="选择城市"
      @click="visionShow = true"
    />

    <van-popup v-model="visionShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="visionShow = false"
        @confirm="onConfirm"
      />
    </van-popup> -->
  </div>
</template>

<script>
let arr = [
  {
    key: "age",
    tit: "您现在的年龄？",
  },
  {
    key: "vision",
    tit: "您的裸眼视力?",
  },
  {
    key: "problem",
    tit: "您想要解决的问题?",
  },
];
import vision from "./component/vision.vue";
import data from "./data.js";
import ruoshi_1 from "../../assets/ruoshi_1.png";
import ruoshi_2 from "../../assets/ruoshi_2.png";
import shipilao_1 from "../../assets/shipilao_1.png";
import shipilao_2 from "../../assets/shipilao_2.png";
import laohua_1 from "../../assets/laohua_1.png";
import laohua_2 from "../../assets/laohua_2.png";

export default {
  components: { vision },
  name: "Questionnaire_Inform",
  data() {
    const now = new Date();
    return {
      isTipShow: false,
      problem: "问卷调查",
      maxDate: new Date(), // 2023年12月31日
      minDate: new Date(now.getFullYear() - 60, now.getMonth(), now.getDate()), // 2023年1月1日
      // 基础问题
      foundation: [...arr],
      questionIndex: 0,
      questionList: [
        {
          id: 1,
          iocn: ruoshi_1,
          iocn_a: ruoshi_2,
          name: "弱视治疗",
          key: "ruoshiInfo",
        },
        {
          id: 3,
          iocn: shipilao_1,
          iocn_a: shipilao_2,
          name: "改善视疲劳",
          key: "shipilaoInfo",
        },
        {
          id: 4,
          iocn: laohua_1,
          iocn_a: laohua_2,
          name: "延缓老花老化",
          key: "laohuaInfo",
        },
      ],
      age: 0,
      foundationIindex: 0,
      show: false,
      pace: 0,
      currentDate: new Date(),
      //
      list: data.ruoshiInfo,
      info: data.moban,
      //
      valueVisionS: {},
    };
  },
  filters: {
    currentDateF(time) {
      if (!time) return new Date();
      let date = new Date(time);
      return date.getFullYear();
    },
  },

  mounted() {
    if (this.$store.state.global.userAge) {
      this.age = this.$store.state.global.userAge;
    } else {
      this.getAge();
    }

    this.foundation.push(...data.ruoshiInfo);
  },
  methods: {
    onNext() {
      if (this.$store.state.global.isFirst) {
        this.$store.state.global.itemNum = 1;
      } else {
        this.$store.state.global.itemNum = 0;
      }
      this.isTipShow = false;

      if (this.$store.state.global.personalInformationBol) {
        this.$router.replace("/commonDescription");
      } else {
        this.$router.replace("/personalInformation");
      }
    },
    option(index) {
      this.next(index);
    },
    onSelect(index) {
      this.questionIndex = index;
      this.foundation = [...arr];
      // if (this.pace == 2) {
      let list = data.ruoshiInfo;
      let key = this.questionList[this.questionIndex].key;
      list = data[key];
      this.foundation.push(...list);
      // }
    },
    visionChang(e) {
      this.valueVisionS = e;
      this.next();
    }, // 视力选择
    openVision() {
      this.visionShow = true;
    },
    confirm() {
      this.show = false;
      this.getAge();
    },
    // 计算年龄
    getAge() {
      const today = new Date();
      const birthDate = new Date(this.currentDate);
      this.age = today.getFullYear() - birthDate.getFullYear();
      console.log("this.$store.state.global.userAge");
      console.log(this.$store.state);
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    next(index) {
      this.handleData(index);

      if (this.pace + 1 >= this.foundation.length) {
        this.sendWenJuan();
        return;
      }
      this.pace++;
    },
    sendWenJuan() {
      this.$store.state.global.wenJuan = this.info;

      this.$axios({
        url:
          this.$store.state.global.padUrl +
          "/visualplatpad/detector-report/save",
        method: "post",
        data: {
          globalId: this.$store.state.global.globalId,
          testType: 99,
          testResult: JSON.stringify({
            data: this.$store.state.global.wenJuan,
          }),
        },
        headers: {
          Authorization: "Bearer " + this.$store.state.global.token,
          serverFlag: "",
          dsName: "",
          "content-type": "application/json",
        },
      });
      this.isTipShow = true;
    },
    // 数据处理
    handleData(index) {
      let pace = this.pace;
      let item = this.foundation[this.pace];
      let key = item.key;

      if (pace == 0) {
        this.info.basicInfo[key] = this.age;
      }
      if (pace == 1) {
        this.info.basicInfo = { ...this.info.basicInfo, ...this.valueVisionS };
      }
      if (pace == 2) {
        this.info.basicInfo[key] = this.questionList[this.questionIndex].id;
        // 'problem':null,//1弱视治疗2斜视术后康复3改善视疲劳4延缓老花老化
      }
      if (pace >= 3) {
        let key2 = this.questionList[this.questionIndex].key;
        if (key == "Vision") {
          this.info[key2] = { ...this.info[key2], ...this.valueVisionS };
        } else {
          this.info[key2][key] = index;
        }
      }
      // console.log(JSON.stringify(this.info));
    },
  },

  computed: {
    questionnaire() {
      let str = "111";
      // if (this.pace >= 3) {
      //   return this.list[0].tit;
      // } else {

      // }

      str = this.foundation[this.pace].tit;
      return str;
    },
  },
};
</script>

<style scoped>
.container {
  background: #8ec2ff;
}
.wenjuan {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/beijing.png");
  background-size: 100%;
  position: relative;
}
.prev {
  position: absolute;
  top: 2vh;
  right: 4vw;
}
#imgContainer p {
  position: absolute;
  left: 50%;
  top: 85%;
  transform: translate(-50%, 0%);
  font-size: 3vw;
  white-space: nowrap;
}
#showImg {
  position: absolute;
  width: 100%;
}
.btnNext {
  background: rgb(1, 220, 195);
  color: rgb(255, 255, 255);
  position: absolute;
  width: 30vw;
  border-radius: 2vw;
  height: 10vw;
  text-align: center;
  line-height: 10vw;
  font-size: 4vw;
  left: 35vw;
  top: 90%;
}
#imgContainer {
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  position: relative;
}
.maotouy {
  width: 22vw;
  margin: 0 2vw;
}
.main {
  background-color: #fff;
  height: 75vh;
  border-radius: 24px 24px 0px 0px;
  position: absolute;
  width: 100vw;
  bottom: 0;
  /* z-index: 3; */
}
.problem_box {
  display: flex;
  align-items: flex-start;
  position: absolute;
  bottom: 75vh;
  transform: translateY(20%);
  /* top: 14vh; */
  /* z-index: 3; */
  width: 100%;
}

.union {
  position: absolute;
  width: 50vw;
  left: 28vw;
  top: 20%;
  padding: 10px;
  /* min-height: 6vh; */
  border-radius: 0px 20px 20px 20px;
  /* background: url("../../assets/union.png"); */
  background-size: 100%;
  background-color: #fff;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4vw;
  line-height: 1.2;
}
.union::before {
  content: "";
  display: block;
  width: 10px;
  height: 14px;
  background: url("../../assets/jiao.png") 100% 100% no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-100%);
}
.btnFooter {
  position: absolute;
  left: 50%;
  bottom: 10vh;
  transform: translate(-50%, 0%);

  width: 80vw;
  height: 11vw;
  border-radius: 5vw;
  text-align: center;
  line-height: 11vw;
  font-size: 4vw;
  background: rgb(41, 123, 255);
  color: white;
}
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 4vw;
  box-sizing: border-box;
}
.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 20vh;
  width: 100%;
}
.select_date {
  flex: 1;
  background-color: #f6f7f5;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  padding: 0 8vw;
}
.select_date span {
  flex: 1;
  color: #a5a6a5;
}
.ages,
.question {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.question .items {
  display: flex;
  flex-wrap: wrap;
}
.question .items .item {
  padding: 2vw;
  width: 50%;
  box-sizing: border-box;
}
.question .items .icon img {
  width: 10vw;
  height: 10vw;
}
.question .items .item .item_nr .icon {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.question .items .item .item_nr {
  background-color: #f6f7f5;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 20vh;
  border-radius: 10px;
  box-sizing: border-box;

  padding: 4vw 3vw;
}

.question .items .item .item_nr.name {
  margin: 2vw 0;
}
.question .items .item_a .item_nr {
  background-color: #d5e8ff;
}
.question .items .item_a .item_nr .name {
  color: #51a1ff;
}
.ages_nr {
  margin-top: 4vh;
}
.age_num {
  width: 20vw;
  font-size: 16vw;
  font-weight: 600;
  color: #51a1ff;
}
.ages .tite {
  color: #9e9e9e;
}
.vision {
  flex: 1;
}

.box {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
}
.flex {
  display: flex;
}
.margin_lr {
  margin: 0 10vw;
}
.padding_lr {
  padding: 0 10vw;
}
.option-item {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f7f5;
  margin: 2vh 0;
  padding: 5vw;
  border-radius: 40px;
  padding-left: 8vw;
  color: #121212;
  width: 100%;
  box-sizing: border-box;
}
</style>
